import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import HotelsTable from './HotelsTable';
import { Link } from 'react-router-dom';

const Hotels = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Hotels" title="Hotels" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Hotels</H5>
                <Link to="/hotels/new">
                  <Btn color="primary">New hotel</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <HotelsTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Hotels;
